import { connect } from 'react-redux';
import { withCustomMetrics } from '@zocdoc/frontend-metrics';

import { LocationPicker as BaseLocationPicker } from './LocationPicker';
import { updateLocation } from '../../actions';

export const mapDispatchToProps = {
    updateLocation,
};

export const LocationPicker = connect(
    undefined, mapDispatchToProps, null, { withRef: true }
)(
    withCustomMetrics({ component: 'LocationPicker' })(
        BaseLocationPicker
    )
);
